import React from "react";
import { useB4CarbonRetirements } from "./useB4CarbonRetirements";
import B4BenefitSharingSection from "./B4BenefitSharingSection";
import B4CarbonRetirementsSection from "./B4CarbonRetirementsSection";

export default function B4CompensationsArea() {
  const { retirements, loading, error, totalCredits, reload } =
    useB4CarbonRetirements();

  return (
    <>
      <B4BenefitSharingSection totalCredits={totalCredits} loading={loading} />
      <B4CarbonRetirementsSection
        retirements={retirements}
        loading={loading}
        error={error}
        onRetry={reload}
      />
    </>
  );
}
